"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LinkPanelBoundary = _interopRequireDefault(require("./LinkPanelBoundary"));
var _LinkAccordion = _interopRequireDefault(require("./LinkAccordion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A panel of links that is intended to be rendered inside a FooterSitemap
 * component.
 *
 * This component traps errors from rendering, and will render an empty `div`
 * if there are any errors during rendering.
 */
const LinkPanel = props => /*#__PURE__*/_react.default.createElement(_LinkPanelBoundary.default, {
  name: "LinkPanel"
}, /*#__PURE__*/_react.default.createElement(_LinkAccordion.default, props));
LinkPanel.propTypes = {
  eventKey: _propTypes.default.string.isRequired,
  small: _propTypes.default.bool.isRequired,
  subtree: _propTypes.default.any.isRequired
};
LinkPanel.defaultProps = {
  eventKey: '0',
  small: false,
  subtree: {}
};
var _default = exports.default = LinkPanel;